<template>
  <div id="app" >
    <router-view></router-view>
  </div>
</template>
<script>

export default {
mounted(){

}
}
</script>
<style >
 @font-face {
		font-family:Bold;
	     src:url("https://sxoffcia-font.oss-cn-chengdu.aliyuncs.com/Alibaba-PuHuiTi-Bold.ttf");
	 }
   @font-face {
		font-family:Heavy;
	     src:url("https://sxoffcia-font.oss-cn-chengdu.aliyuncs.com/Alibaba-PuHuiTi-Heavy.ttf");
	 }
   @font-face {
		font-family:Light;
	     src:url("https://sxoffcia-font.oss-cn-chengdu.aliyuncs.com/Alibaba-PuHuiTi-Light.ttf");
	 }
   @font-face {
		font-family:Medium;
	     src:url("https://sxoffcia-font.oss-cn-chengdu.aliyuncs.com/Alibaba-PuHuiTi-Medium.ttf");
	 }
   @font-face {
		font-family:Regular;
	     src:url("https://sxoffcia-font.oss-cn-chengdu.aliyuncs.com/Alibaba-PuHuiTi-Regular.ttf");
	 }
#app{
  margin: 0 auto;
}
*{
	
  margin: 0;padding: 0;list-style: none;
  box-sizing: border-box;
  scroll-behavior: smooth;
  /* pointer-events: none */
  user-select: none
}
a{
  text-decoration: none;
  color: inherit;
}
</style>
